import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "map-container" }
const _hoisted_2 = {
  class: "map-controls boutonFlottante mb-3",
  style: {"display":"flex","flex-direction":"row","align-items":"center","gap":"0.5rem","flex-wrap":"nowrap"}
}
const _hoisted_3 = {
  class: "badge bg-success",
  style: {"white-space":"nowrap"}
}
const _hoisted_4 = {
  class: "popup-content",
  style: {"display":"flex","flex-direction":"row","align-items":"flex-start","gap":"1rem"}
}
const _hoisted_5 = {
  key: 0,
  style: {"flex":"1","min-width":"100px","height":"260px","display":"flex","align-items":"center","justify-content":"center","background-image":"url('/mer.jpg')","background-size":"cover","background-position":"center"}
}
const _hoisted_6 = {
  key: 0,
  src: "/navire_jaune.png",
  alt: "Navire",
  style: {"height":"40px","width":"auto","object-fit":"contain","transform":"rotate(-90deg)","display":"block"}
}
const _hoisted_7 = {
  key: 1,
  src: "/navire.png",
  alt: "Navire",
  style: {"height":"40px","width":"auto","object-fit":"contain","transform":"rotate(-90deg)","display":"block"}
}
const _hoisted_8 = {
  key: 1,
  style: {"min-width":"120px","height":"290px","align-items":"center","justify-content":"center","background-image":"url('/tuyau.jpg')","background-size":"cover","background-position":"center"}
}
const _hoisted_9 = { style: {"flex":"1","min-width":"160px"} }
const _hoisted_10 = {
  key: 0,
  class: "mb-1"
}
const _hoisted_11 = { style: {"border":"1"} }
const _hoisted_12 = {
  key: 0,
  style: {"color":"green"}
}
const _hoisted_13 = {
  key: 1,
  style: {"color":"red"}
}
const _hoisted_14 = { class: "text-muted" }
const _hoisted_15 = { class: "popup-content" }
const _hoisted_16 = { class: "text-muted" }

import { ref, computed, onMounted, onUnmounted, watch } from 'vue';
import L from 'leaflet';
import { LMap, LTileLayer, LMarker, LPopup, LIcon, LPolyline, LRectangle, LCircle } from '@vue-leaflet/vue-leaflet';
import 'leaflet/dist/leaflet.css';
import { Field } from 'vee-validate';
import Multiselect from '@vueform/multiselect';

// Import de la fonction utilitaire
import { isPointInZEE } from './isPointInZEE';

// import { defineEmits } from 'vue';
import ApiService from '@/services/ApiService';
// eslint-disable-next-line no-undef
interface MarkerData {
  lat: number;
  lng: number;
  title?: string;
  description?: string;
  color?: string;
  mmsi?: string;
  imo?: string;
  type?: string;
  speed?: number;
  destination?: string;
  country_iso?: string;
  eta_utc?: string;
  last_reported_utc?: string;
  heading?: string;
}

interface ZeeBounds {
  minLat: number;
  maxLat: number;
  minLng: number;
  maxLng: number;
}

interface ZeeCenter {
  lat: number;
  lng: number;
}

// Props
interface Props {
  markers?: MarkerData[];
  initialZoom?: number;
  initialCenter?: [number, number];
  showLines?: boolean;
  lineColor?: string;
  showZEE?: boolean;
  zeeBounds?: ZeeBounds;
  zeeCenter?: ZeeCenter;
  zeeGeoJson?: any;
  specialCircle?: {
    lat: number;
    lng: number;
    radius: number; // en mètres
  };
  zonesScannage?: {
    lat: number;
    lng: number;
    radius: number; // en mètres
  }[];
}



// État réactif

export default /*@__PURE__*/_defineComponent({
  __name: 'StreetMaps',
  props: {
    markers: { default: () => [] },
    initialZoom: { default: 6 },
    initialCenter: { default: () => [-18.8792, 47.5079] },
    showLines: { type: Boolean, default: false },
    lineColor: { default: '#3388ff' },
    showZEE: { type: Boolean, default: false },
    zeeBounds: { default: undefined },
    zeeCenter: { default: undefined },
    zeeGeoJson: { default: undefined },
    specialCircle: {},
    zonesScannage: {}
  },
  emits: ['zone-changed'],
  setup(__props: any, { emit: __emit }) {


// Recherche multi-critères navire
const searchNavire = ref('');

// import { ref, computed, onMounted, onUnmounted, withDefaults, defineProps, watch } from 'vue';
// Fonction de filtre personnalisée pour le Multiselect navires

const emit = __emit;
// eslint-disable-next-line no-undef
const props = __props;

// Index du marqueur sélectionné (pour le multiselect)
const selectedMarkerIndex = ref<number>(-1);
const selectedTypeNavire = ref<string>('');

//######################################
// Index de la zone de scannage sélectionnée (par défaut: 0 si zonesScannage existe)
const selectedZoneIndex = ref<number>((props.zonesScannage && props.zonesScannage.length > 0) ? 0 : -1);
// Options pour le select des zones de scannage
const zoneOptions = computed(() => {
  if (!props.zonesScannage || props.zonesScannage.length === 0) return [];
  return props.zonesScannage.map((z, idx) => ({
    label: `Zone ${idx + 1} (lat: ${z.lat}, lng: ${z.lng})`,
    value: idx
  }));
});


// Fonction pour vérifier si un point est dans la ZEE
function isInZEE(marker) {
  try {

    // enregistrement du navire
    // if(isPointInZEE(marker)){
    //   ApiService.post('/vessels', { marker})
    //   .then((data) => {
    //     console.log('Navire enregistré avec succès.');
    //   }).catch((error) => {
    //     console.error('Erreur lors de l\'enregistrement du navire:', error);
    //   });
    // }

    return isPointInZEE(marker);
  } catch (e) {
    return false;
  }
}

// Watch pour sélectionner automatiquement la première zone si la prop change
watch(
  () => props.zonesScannage,
  (zones) => {
    if (zones && zones.length > 0) {
      selectedZoneIndex.value = 0;
    } else {
      selectedZoneIndex.value = -1;
    }
  },
  { immediate: true }
);

// Emit au parent à chaque changement de zone sélectionnée
watch(selectedZoneIndex, (newIndex) => {
  if (props.zonesScannage && props.zonesScannage[newIndex]) {
    emit('zone-changed', props.zonesScannage[newIndex]);
  }
});

// Zone sélectionnée
const selectedZone = computed(() => {
  if (!props.zonesScannage || selectedZoneIndex.value < 0) return null;
  return props.zonesScannage[selectedZoneIndex.value];
});

//#####################################"


// --- Ajout : gestion des navires dynamiques ---


const dynamicMarkers = ref<any[]>([]);
let intervalId: any = null;


async function fetchNaviresPositions() {
  console.log("Fetching vessels positions...");
  ApiService.get('/vessels/positions')
    .then((response) => {
      if (response && Array.isArray(response.data)) {
        console.log("Navires récupérés:", response.data.length);
        // dynamicMarkers.value = response.data;
      } else {
        console.log("Aucun navire récupéré");
        // dynamicMarkers.value = [];
      }
    })
    .catch((error) => {
      console.error('Erreur lors de la récupération des positions des navires:', error);
      dynamicMarkers.value = [];
    });

  // console.log("Nous sommes là", props.markers.length);
  // const promises = props.markers.map(async (marker) => {
  //   if (!marker.mmsi) return marker;
  //   try {
  //     const data = await ApiService.get(`/vesselpro/${marker.mmsi}`);
  //     // Fusionne les données API avec le marqueur original
  //     return { ...marker, ...data };
  //   } catch (error) {
  //     console.log("Erreur Datalastic:", error);
  //     return marker;
  //   }
  // });
  // const results = await Promise.all(promises);
  // dynamicMarkers.value = results;
}

// Icône clignotante pour le marqueur sélectionné
// function createSelectedIcon() {
//   // Taille dynamique selon le zoom
//   const baseSize = 22;
//   const scale = Math.max(0.7, Math.min(2, zoom.value / 10));
//   const size = baseSize * scale;
//   return L.divIcon({
//     className: 'blinking-marker',
//     iconSize: [size, size],
//     iconAnchor: [size / 2, size / 2],
//     popupAnchor: [0, -size / 2],
//     html: `<div style="width:${size * 0.73}px;height:${size * 0.73}px;border-radius:50%;background:#32db5a;box-shadow:0 0 2px #333;"></div>`
//   });
// }

function createSelectedIcon() {
  // Taille dynamique selon le zoom
  const baseSize = 22;
  const scale = Math.max(0.7, Math.min(2, zoom.value / 10));
  const size = baseSize * scale;
  return L.divIcon({
    className: 'blinking-marker',
    iconSize: [size, size],
    iconAnchor: [size / 2, size / 2],
    popupAnchor: [0, -size / 2],
    html: `<div style="width:${size}px;height:${size}px;display:flex;align-items:center;justify-content:center;">
      <div style="width:${size * 0.73}px;height:${size * 0.73}px;border-radius:50%;background:#32db5a;box-shadow:0 0 2px #333;"></div>
    </div>`
  });
}

function searchNavireFilter(options, search) {
  if (!Array.isArray(options)) return options;
  if (!search || search.trim() === '') return options;
  const q = search.trim().toLowerCase();
  return options.filter(opt => {
    // On récupère l'index du navire
    const idx = typeof opt.value === 'number' ? opt.value : -1;
    const marker = (filteredMarkers.value && filteredMarkers.value[idx]) ? filteredMarkers.value[idx] : null;
    if (!marker) return false;
    return [marker.title, marker.mmsi, marker.imo, marker.eni, marker.type]
      .filter(v => v !== undefined && v !== null)
      .some(v => String(v).toLowerCase().includes(q));
  });
}

// Centrer la carte sur le marqueur sélectionné quand l'index change
watch(selectedMarkerIndex, (idx) => {
  if (
    filteredMarkers.value &&
    filteredMarkers.value[idx] &&
    typeof filteredMarkers.value[idx].lat === 'number' &&
    typeof filteredMarkers.value[idx].lng === 'number'
  ) {
    const latLng: [number, number] = [filteredMarkers.value[idx].lat, filteredMarkers.value[idx].lng];
    zoom.value = 14;
    center.value = latLng;
    if (leafletObject.value && typeof leafletObject.value.panTo === 'function') {
      leafletObject.value.panTo(latLng);
    }
  }
});

// Types
const zoom = ref(props.initialZoom);
const center = ref<[number, number]>([
  Array.isArray(props.initialCenter) && props.initialCenter.length === 2
    ? props.initialCenter[0]
    : -18.8792,
  Array.isArray(props.initialCenter) && props.initialCenter.length === 2
    ? props.initialCenter[1]
    : 47.5079
]);
const map = ref<any>(null);
const leafletObject = ref<any>(null);
const markerOptions = ref<any[]>([]);

// Générer dynamiquement les types de navires à partir des markers
const typeNavireOptions = computed(() => {
  const types = new Set<string>();
  props.markers.forEach(m => {
    if (m.type && m.type.trim() !== '') {
      types.add(m.type);
    }
  });
  return [
    { label: 'Tous types', value: '' },
    ...Array.from(types).sort().map(type => ({ label: type, value: type }))
  ];
});

// Coordonnées calculées pour la polyline
const markerCoordinates = computed(() => {
  const baseMarkers = dynamicMarkers.value.length > 0 ? dynamicMarkers.value : props.markers;
  return baseMarkers.map(m => [m.lat, m.lng]);
});

// Coordonnées pour le rectangle de la ZEE
// const zeeRectangleBounds = computed(() => {
//   if (!props.zeeBounds) return [[0, 0], [0, 0]];
//   return [
//     [props.zeeBounds.minLat, props.zeeBounds.minLng], // Sud-Ouest
//     [props.zeeBounds.maxLat, props.zeeBounds.maxLng]  // Nord-Est
//   ];
// });

// Événement quand la carte est prête
const onMapReady = (mapInstance: any) => {
  map.value = mapInstance;
  leafletObject.value = mapInstance.leafletObject || mapInstance;
  
  if (props.zeeGeoJson && props.zeeGeoJson.features && props.zeeGeoJson.features[0].geometry.type === "MultiPolygon") {
    props.zeeGeoJson.features[0].geometry.coordinates.forEach(polygon => {
      const latLngs = polygon[0].map(([lng, lat]) => [lat, lng]);
      L.polygon(latLngs, { color: "blue", weight: 2, fillOpacity: 0.05 }).addTo(leafletObject.value);
    });
  }

  // Si des marqueurs existent, ajuster la vue
  if (props.markers.length > 0) {
    setTimeout(() => fitBounds(), 100);
    // construit un objet avec label toujours défini
    markerOptions.value = props.markers.map((m, idx) => ({
      label: m.title && m.title.trim() !== '' ? m.title + ' - '+ m.mmsi : `Point ${idx + 1}`,
      value: idx,
    }));
  }
};

// Toujours synchroniser les options et l'index sélectionné avec les markers quand ils changent
watch(
  () => props.markers,
  (newMarkers) => {
    markerOptions.value = newMarkers.map((m, idx) => ({
      label: m.title && m.title.trim() !== '' ? m.title : `Point ${idx + 1}`,
      value: idx,
    }));
    selectedMarkerIndex.value = -1;
    // fetchNaviresPositions();
  },
  { immediate: true, deep: true }
);



// const zeePolygonLatLngs = geoJsonMultiPolygonToLatLngs(props.zeeGeoJson);

// Centrer la carte sur le premier marqueur ou la position initiale
const centerMap = () => {
  if (props.markers.length > 0) {
    center.value = [props.markers[0].lat, props.markers[0].lng];
    zoom.value = 12;
  } else {
    center.value = props.initialCenter;
    zoom.value = props.initialZoom;
  }
};

// Ajuster la vue pour afficher tous les marqueurs
const fitBounds = () => {
  const leafletMap = leafletObject.value || map.value?.leafletObject;
  const baseMarkers = dynamicMarkers.value.length > 0 ? dynamicMarkers.value : props.markers;
  if (leafletMap && baseMarkers.length > 0) {
    const bounds = baseMarkers.map(m => [m.lat, m.lng]);
    try {
      leafletMap.fitBounds(bounds, { padding: [50, 50] });
    } catch (error) {
      console.warn('Erreur lors de fitBounds:', error);
    }
  }
};

// Utilitaire pour créer un vrai point rouge sans carré blanc (DivIcon)
function createRedDotIcon(marker) {
  // Taille dynamique selon le zoom
  const baseWidth = 36, 
  baseHeight = 16;
  const scale = Math.max(0.7, Math.min(2, zoom.value / 10));
  // const scale = Math.max(0.7, zoom.value / 10);
  const width = baseWidth * scale;
  const height = baseHeight * scale;
  switch (true) {
    case !!marker && marker.type === 'Special Mark - Sea Farm': {
      // Plus petit et rouge
      const small = Math.min(width, height) * 0.6;
      return L.divIcon({
        className: '',
        iconSize: [small, small],
        iconAnchor: [small / 2, small / 2],
        popupAnchor: [0, -small / 2],
        html: `<div style="width:${small}px;height:${small}px;display:flex;align-items:center;justify-content:center;">
          <div style="width:${small * 0.8}px;height:${small * 0.8}px;background:#dc3545;box-shadow:0 0 1px #333;"></div>
        </div>`
      });
    }
    case !!marker && marker.type === 'Fishing': {
      // Plus petit et rouge
      const small = Math.min(width, height) * 0.6;
        const heading = marker && typeof marker.heading !== 'undefined' ? parseInt(marker.heading, 10) - 90 : 0;
      return L.divIcon({
        className: '',
        iconSize: [small, small],
        iconAnchor: [small / 2, small / 2],
        popupAnchor: [0, -small / 2],
        // html: `
        // <div style="width:${width}px;height:${height}px;display:flex;align-items:center;justify-content:center;">
        //   <svg width="${width}" height="${height}" viewBox="0 0 36 16" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(${heading}deg);display:block;">
        //     <polygon points="2,2 28,2 35,8 28,14 2,14" fill="#fcd703" stroke="#333" stroke-width="1" />
        //     <circle cx="25" cy="8" r="3" fill="#fff" stroke="#333" stroke-width="1" />
        //   </svg>
        // </div>
        // `
        html: `
          <div style="width:${width}px;height:${height}px;display:flex;align-items:center;justify-content:center;background:transparent;border:none;padding:0;">
            <img src="/navire_jaune.png" alt="Navire" style="width:${width * 0.95}px;height:${height * 0.95}px;object-fit:contain;transform: rotate(${heading}deg);display:block;" />
          </div>
        `
      });
    }
    // Ajoutez d'autres cas ici si besoin
  }
  const heading = marker && typeof marker.heading !== 'undefined' ? parseInt(marker.heading, 10) - 90 : 0;
  return L.divIcon({
    className: '',
    iconSize: [width, height],
    iconAnchor: [width / 2, height / 2],
    popupAnchor: [0, -height / 2],
    // html: `
    //   <div style="width:${width}px;height:${height}px;display:flex;align-items:center;justify-content:center;">
    //     <svg width="${width}" height="${height}" viewBox="0 0 36 16" xmlns="http://www.w3.org/2000/svg" style="transform: rotate(${heading}deg);display:block;">
    //       <polygon points="2,2 28,2 35,8 28,14 2,14" fill="#90ee90" stroke="#333" stroke-width="1" />
    //       <circle cx="25" cy="8" r="3" fill="#fff" stroke="#333" stroke-width="1" />
    //     </svg>
    //   </div>
    // `
    html: `
      <div style="width:${width}px;height:${height}px;display:flex;align-items:center;justify-content:center;background:transparent;border:none;padding:0;">
        <img src="/navire.png" alt="Navire" style="width:${width * 0.95}px;height:${height * 0.95}px;object-fit:contain;transform: rotate(${heading}deg);display:block;" />
      </div>
    `
  });
}



// Forcer le rafraîchissement des marqueurs à chaque changement de zoom
watch(zoom, () => {
  console.log("Zoom changed, refreshing markers.", zoom.value);
  // Changer la valeur d'un dummy pour forcer le rendu si besoin
  // Ici, on s'appuie sur le fait que createRedDotIcon et createSelectedIcon utilisent zoom.value
});
// Réinitialise l'index sélectionné si le filtre exclut l'élément sélectionné

// Marqueurs filtrés selon le type sélectionné
const filteredMarkers = computed(() => {
  const baseMarkers = dynamicMarkers.value.length > 0 ? dynamicMarkers.value : props.markers;
  // Filter out markers with invalid lat/lng
  const validMarkers = baseMarkers.filter(m => m && m.lat !== undefined && m.lng !== undefined);
  if (!selectedTypeNavire.value) return validMarkers;
  return validMarkers.filter(m => m.type === selectedTypeNavire.value);
});

// Marqueurs filtrés selon le type sélectionné
// const filteredMarkers = computed(() => {
//   const baseMarkers = dynamicMarkers.value.length > 0 ? dynamicMarkers.value : props.markers;
//   // Filter out markers with invalid lat/lng
//   let validMarkers = baseMarkers.filter(m => m && m.lat !== undefined && m.lng !== undefined);
//   // Filtre par type
//   if (selectedTypeNavire.value) {
//     validMarkers = validMarkers.filter(m => m.type === selectedTypeNavire.value);
//   }
//   // Filtre multi-critères texte
//   if (searchNavire.value && searchNavire.value.trim() !== '') {
//     const q = searchNavire.value.trim().toLowerCase();
//     validMarkers = validMarkers.filter(m => {
//       return (
//         (m.title && m.title.toLowerCase().includes(q)) ||
//         (m.mmsi && String(m.mmsi).toLowerCase().includes(q)) ||
//         (m.imo && String(m.imo).toLowerCase().includes(q)) ||
//         (typeof m.eni !== 'undefined' && m.eni !== null && String(m.eni).toLowerCase().includes(q)) ||
//         (m.type && m.type.toLowerCase().includes(q))
//       );
//     });
//   }
//   return validMarkers;
// });

// watch(filteredMarkers, (newMarkers) => {
//   if (
//     selectedMarkerIndex.value >= newMarkers.length ||
//     selectedMarkerIndex.value < 0 ||
//     !newMarkers[selectedMarkerIndex.value]
//   ) {
//     selectedMarkerIndex.value = -1;
//   }
// });

onMounted(() => {
  // Initialisation supplémentaire si nécessaire
  console.log('showZEE:', props.showZEE, 'zeeGeoJson:', props.zeeGeoJson);
  // fetchNaviresPositions();
  intervalId = setInterval(fetchNaviresPositions, 30000); // toutes les 30s
});

onUnmounted(() => {
  if (intervalId) clearInterval(intervalId);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Multiselect), {
          modelValue: selectedZoneIndex.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedZoneIndex).value = $event)),
          options: zoneOptions.value,
          searchable: true,
          "filter-results": true,
          label: "label",
          mode: "single",
          placeholder: "Sélectionner une zone de scannage...",
          class: "me-1 d-inline-block",
          style: {"min-width":"200px","max-width":"260px"}
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_unref(Multiselect), {
          modelValue: selectedMarkerIndex.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((selectedMarkerIndex).value = $event)),
          options: markerOptions.value,
          searchable: true,
          "filter-results": true,
          "search-filter": searchNavireFilter,
          label: "label",
          mode: "single",
          placeholder: "Sélectionner le navire...",
          class: "me-1 d-inline-block",
          style: {"min-width":"250px","max-width":"260px"}
        }, null, 8, ["modelValue", "options"]),
        _createVNode(_unref(Multiselect), {
          modelValue: selectedTypeNavire.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((selectedTypeNavire).value = $event)),
          options: typeNavireOptions.value,
          searchable: true,
          "filter-results": true,
          label: "label",
          mode: "single",
          placeholder: "Sélectionner un type de navire...",
          class: "me-1 d-inline-block",
          style: {"min-width":"200px","max-width":"220px"}
        }, null, 8, ["modelValue", "options"]),
        _createElementVNode("button", {
          onClick: centerMap,
          class: "btn btn-primary btn-sm me-1",
          style: {"white-space":"nowrap"}
        }, [...(_cache[5] || (_cache[5] = [
          _createElementVNode("i", { class: "bi bi-crosshair" }, null, -1),
          _createTextVNode(" Centrer la carte ", -1)
        ]))]),
        _createElementVNode("button", {
          onClick: fitBounds,
          class: "btn btn-secondary btn-sm me-1",
          style: {"white-space":"nowrap"}
        }, [...(_cache[6] || (_cache[6] = [
          _createElementVNode("i", { class: "bi bi-arrows-fullscreen" }, null, -1),
          _createTextVNode(" Ajuster aux marqueurs ", -1)
        ]))]),
        _createElementVNode("span", _hoisted_3, [
          _cache[7] || (_cache[7] = _createElementVNode("i", { class: "bi bi-pin-map-fill me-1" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(filteredMarkers.value.length) + " navires ", 1)
        ])
      ])
    ]),
    _createVNode(_unref(LMap), {
      ref_key: "map",
      ref: map,
      zoom: zoom.value,
      "onUpdate:zoom": _cache[3] || (_cache[3] = ($event: any) => ((zoom).value = $event)),
      center: center.value,
      "onUpdate:center": _cache[4] || (_cache[4] = ($event: any) => ((center).value = $event)),
      "use-global-leaflet": false,
      style: {"width":"100%","height":"calc(100vh - 60px)","min-height":"300px"},
      onReady: onMapReady
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_unref(LCircle), {
          "lat-lng": selectedZone.value ? [selectedZone.value.lat, selectedZone.value.lng] : [0,0],
          radius: selectedZone.value ? selectedZone.value.radius : 0,
          color: "#28a745",
          "fill-color": "#28a745",
          "fill-opacity": 0.18
        }, null, 8, ["lat-lng", "radius"]), [
          [_vShow, selectedZone.value]
        ]),
        _createVNode(_unref(LTileLayer), {
          url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
          attribution: "© <a href=\"https://www.openstreetmap.org/copyright\">OpenStreetMap</a> contributors",
          "layer-type": "base",
          name: "OpenStreetMap"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMarkers.value, (marker, index) => {
          return (_openBlock(), _createBlock(_unref(LMarker), {
            key: index,
            "lat-lng": [marker.lat, marker.lng],
            icon: index === selectedMarkerIndex.value ? createSelectedIcon() : createRedDotIcon(marker)
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(LPopup), null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    (marker.type !== 'Special Mark - Sea Farm')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (marker.type==='Fishing')
                            ? (_openBlock(), _createElementBlock("img", _hoisted_6))
                            : (_openBlock(), _createElementBlock("img", _hoisted_7))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8)),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h6", null, _toDisplayString(marker.title || `Point ${index + 1}`), 1),
                      (marker.description)
                        ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(marker.description), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("table", _hoisted_11, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _cache[8] || (_cache[8] = _createElementVNode("th", { style: {"min-width":"70px","font-size":"12px"} }, "MMSI", -1)),
                            _createElementVNode("td", null, _toDisplayString(marker.mmsi || 'N/A'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[9] || (_cache[9] = _createElementVNode("th", { style: {"min-width":"70px","font-size":"12px"} }, "IMO", -1)),
                            _createElementVNode("td", null, _toDisplayString(marker.imo || 'N/A'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[10] || (_cache[10] = _createElementVNode("th", { style: {"min-width":"70px","font-size":"12px"} }, "Type", -1)),
                            _createElementVNode("td", null, _toDisplayString(marker.type || 'N/A'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[11] || (_cache[11] = _createElementVNode("th", { style: {"min-width":"70px","font-size":"12px"} }, "Vitesse", -1)),
                            _createElementVNode("td", null, _toDisplayString(marker.speed !== undefined ? marker.speed + ' kn' : 'N/A'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[12] || (_cache[12] = _createElementVNode("th", { style: {"min-width":"70px","font-size":"12px"} }, "Destination", -1)),
                            _createElementVNode("td", null, _toDisplayString(marker.destination || 'N/A'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[13] || (_cache[13] = _createElementVNode("th", { style: {"min-width":"70px","font-size":"12px"} }, "Pays", -1)),
                            _createElementVNode("td", null, _toDisplayString(marker.country_iso || 'N/A'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[14] || (_cache[14] = _createElementVNode("th", { style: {"min-width":"70px","font-size":"12px"} }, "ETA (UTC)", -1)),
                            _createElementVNode("td", null, _toDisplayString(marker.eta_utc || 'N/A'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[15] || (_cache[15] = _createElementVNode("th", { style: {"min-width":"70px","font-size":"12px"} }, "Heading", -1)),
                            _createElementVNode("td", null, _toDisplayString(marker.heading || 'N/A'), 1)
                          ]),
                          _createElementVNode("tr", null, [
                            _cache[16] || (_cache[16] = _createElementVNode("th", { style: {"min-width":"70px","font-size":"12px"} }, " Est dans la ZEE ", -1)),
                            _createElementVNode("td", null, [
                              (isInZEE(marker))
                                ? (_openBlock(), _createElementBlock("span", _hoisted_12, " Oui"))
                                : (_openBlock(), _createElementBlock("span", _hoisted_13, " Non"))
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("small", _hoisted_14, [
                        (marker.lat !== undefined && marker.lng !== undefined)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(" Lat: " + _toDisplayString(Number(marker.lat).toFixed(6)) + ", Lng: " + _toDisplayString(Number(marker.lng).toFixed(6)), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createTextVNode(" Coordonnées non disponibles ")
                            ], 64))
                      ])
                    ])
                  ])
                ]),
                _: 2
              }, 1024)
            ]),
            _: 2
          }, 1032, ["lat-lng", "icon"]))
        }), 128)),
        (__props.showZEE && __props.zeeCenter)
          ? (_openBlock(), _createBlock(_unref(LMarker), {
              key: 0,
              "lat-lng": [__props.zeeCenter.lat, __props.zeeCenter.lng]
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(LIcon), {
                  "icon-size": [24, 24],
                  "icon-anchor": [12, 12],
                  "popup-anchor": [0, -12]
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createElementVNode("div", { class: "custom-marker" }, [
                      _createElementVNode("i", {
                        class: "bi bi-bullseye",
                        style: {"color":"#0066cc","font-size":"24px"}
                      })
                    ], -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_unref(LPopup), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[18] || (_cache[18] = _createElementVNode("h6", null, "Centre de la ZEE", -1)),
                      _createElementVNode("small", _hoisted_16, " Lat: " + _toDisplayString(__props.zeeCenter.lat.toFixed(5)) + "°, Lng: " + _toDisplayString(__props.zeeCenter.lng.toFixed(5)) + "° ", 1)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["lat-lng"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["zoom", "center"])
  ], 64))
}
}

})